import useOffersLoader from "../common/useOffersLoader";

const useReceiverSideEffects = (): void => {
  useOffersLoader();
};
export default useReceiverSideEffects;
